export enum SmTableColumnWidthMode {
    Default = "default",
    ContentFlex = "contentFlex",
    Content = "content",
    ContentNoExpand = "contentNoExpand"
}